import { createReducer } from 'redux-act';
import actions from '../actions/designationAction';

const initialState = {
  addDesignationPending: false,
  addDesignationRes: null,
  addDesignationError: null,

  getAllDesignationPending: false,
  getAllDesignationRes: null,
  getAllDesignationError: null,

  getDesignationsByDepartmentPending: false,
  getDesignationsByDepartmentRes: null,
  getDesignationsByDepartmentError: null,

  updateDesignationPending: false,
  updateDesignationRes: null,
  updateDesignationError: null,

  deleteDesignationPending: false,
  deleteDesignationRes: null,
  deleteDesignationError: null,
};

/* Add Designation Reducers */
const handleAddDesignationRequest = state => {
  return {
    ...state,
    ...{
      addDesignationPending: true,
      addDesignationRes: null,
      addDesignationError: null,
    },
  };
};
const handleAddDesignationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addDesignationPending: false,
      addDesignationRes: payload,
      addDesignationError: null,
    },
  };
};
const handleAddDesignationError = (state, payload) => ({
  ...state,
  ...{
    addDesignationPending: false,
    addDesignationRes: null,
    addDesignationError: payload,
  },
});


/* Get Designation Reducers */
const handleGetAllDesignationRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllDesignationPending: true,
      getAllDesignationRes: null,
      getAllDesignationError: null,
    },
  };
};
const handleGetAllDesignationSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllDesignationPending: false,
      getAllDesignationRes: payload,
      getAllDesignationError: null,
    },
  };
};
const handleGetAllDesignationError = (state1, payload) => ({
  ...state1,
  ...{
    getAllDesignationPending: false,
    getAllDesignationRes: null,
    getAllDesignationError: payload,
  },
});


/* Get Designation by Department Reducers */
const handleGetDesignationsByDepartmentRequest = state1 => {
  return {
    ...state1,
    ...{
      getDesignationsByDepartmentPending: true,
      getDesignationsByDepartmentRes: null,
      getDesignationsByDepartmentError: null,
    },
  };
};
const handleGetDesignationsByDepartmentSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getDesignationsByDepartmentPending: false,
      getDesignationsByDepartmentRes: payload,
      getDesignationsByDepartmentError: null,
    },
  };
};
const handleGetDesignationsByDepartmentError = (state1, payload) => ({
  ...state1,
  ...{
    getDesignationsByDepartmentPending: false,
    getDesignationsByDepartmentRes: null,
    getDesignationsByDepartmentError: payload,
  },
});

/* Update Designation Reducers*/ 
const handleUpdateDesignationRequest = state1 => {
  return {
    ...state1,
    ...{
      updateDesignationPending: true,
      updateDesignationRes: null,
      updateDesignationError: null,
    },
  };
};
const handleUpdateDesignationSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateDesignationPending: false,
      updateDesignationRes: payload,
      updateDesignationError: null,
    },
  };
};
const handleUpdateDesignationError = (state1, payload) => ({
  ...state1,
  ...{
    updateDesignationPending: false,
    updateDesignationRes: null,
    updateDesignationError: payload,
  },
});

/* Delete Designation Reducers*/ 
const handleDeleteDesignationRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteDesignationPending: true,
      deleteDesignationRes: null,
      deleteDesignationError: null,
    },
  };
};
const handleDeleteDesignationSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteDesignationPending: false,
      deleteDesignationRes: payload,
      deleteDesignationError: null,
    },
  };
};
const handleDeleteDesignationError = (state1, payload) => ({
  ...state1,
  ...{
    deleteDesignationPending: false,
    deleteDesignationRes: null,
    deleteDesignationError: payload,
  },
});

/* Clear Designation Store */
const clearDesignationStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_DESIGNATION_STORE':
      return {
        ...state,
        ...{
          addDesignationPending: false,
          addDesignationRes: null,
          addDesignationError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_DESIGNATION_STORE':
      return {
        ...state,
        ...{
          updateDesignationPending: false,
          updateDesignationRes: null,
          updateDesignationError: null,
        },
      };
      case 'HANDLE_CLEAR_DELETE_DESIGNATION_STORE':
      return {
        ...state,
        ...{
          deleteDesignationPending: false,
          deleteDesignationRes: null,
          deleteDesignationError: null,
        },
      };
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.addDesignationRequest]: handleAddDesignationRequest,
    [actions.addDesignationSuccess]: handleAddDesignationSuccess,
    [actions.addDesignationError]: handleAddDesignationError,

    [actions.getAllDesignationRequest]: handleGetAllDesignationRequest,
    [actions.getAllDesignationSuccess]: handleGetAllDesignationSuccess,
    [actions.getAllDesignationError]: handleGetAllDesignationError,

    [actions.getDesignationsByDepartmentRequest]: handleGetDesignationsByDepartmentRequest,
    [actions.getDesignationsByDepartmentSuccess]: handleGetDesignationsByDepartmentSuccess,
    [actions.getDesignationsByDepartmentError]: handleGetDesignationsByDepartmentError,

    [actions.updateDesignationRequest]: handleUpdateDesignationRequest,
    [actions.updateDesignationSuccess]: handleUpdateDesignationSuccess,
    [actions.updateDesignationError]: handleUpdateDesignationError,

    [actions.deleteDesignationRequest]: handleDeleteDesignationRequest,
    [actions.deleteDesignationSuccess]: handleDeleteDesignationSuccess,
    [actions.deleteDesignationError]: handleDeleteDesignationError,

    [actions.handleClearDesignationStore]: clearDesignationStore,
  },
  initialState,
);